module.exports = __webpack_public_path__ + "img/savoir-faire.3a59cbd1.png";